import { observable } from 'mobx'

import Store from '../shared/store'
import { apiStore } from '../shared/api'
import { apiClient } from '../shared/api-impl'

import { release as config } from '../config'

import Release from './model'

@apiStore(apiClient)
class ReleaseStore extends Store {

  @observable loading = false

  @observable collection = []

  constructor(opts = {}) {

    super(opts)

    this.Model = Release

    this.initAPIStore({
      ...opts,
      api: config.api,
    })

  }

  findByModel(model) {
    return this.collection.find((item) => {
      return item.type === model.type && item.origId * 1 === model.id * 1
    })
  }

  load(...args) {
    return this.api.load(...args)
  }

  save(...args) {
    return this.api.save(...args)
  }

  destroy(...args) {
    return this.api.destroy(...args)
  }

  syncTransaction(thenable) {
    return thenable
      .catch((ex) => {
        throw ex
      })
      .then(() => {
      // reload the collection to make sure we have the data
      // from the sever
        this.load(null, { reset: true })
      // const rejectedModel = this.findByModel(model)
      //
      // if (rejectedModel) {
      //   this.collection.slice(this.collection.indexOf(rejectedModel), 1)
      // }
      })
  }

  release(model) {
    return this.syncTransaction(model.save())
  }

  reject(model, { rejectionMessage }) {

    /* eslint-disable no-underscore-dangle */
    model._message = model._message || {}

    // always reject all as of #65
    const rejectAll = true /* Object.keys(model._message).reduce((memo, key) => {
      return memo && !!model._message[key]
    }, true)*/

    if (rejectionMessage) {
      model._message.general = { message: rejectionMessage }
    }
    /* eslint-enable no-underscore-dangle */

    return this.syncTransaction(model.save({
      params: {
        rejectAll
      }
    }))

  }

  delete(model) {
    return this.syncTransaction(model.destroy())
  }

}

export const releaseStore = new ReleaseStore()



// WEBPACK FOOTER //
// ./src/release/store.js